import { Controller } from 'stimulus';
import gtag from '@/tracking/gtag';

class Hero extends Controller {
  // eslint-disable-next-line class-methods-use-this
  onButtonClick() {
    document.querySelector('body').classList.add('overflow-hidden');

    gtag.event(
      'Slaapwijzer',
      'Click',
      'Start slaapwijzer',
    );
  }
}

Hero.targets = [
  //
];

export default Hero;
